import { InspectionTranslationKeys } from 'intl/keys';
import { TranslationKey } from 'intl/types/translationKey';
import { ComplianceAnswerOption } from 'shared/domain/compliance/complianceAnswerOption';

const COMPLIANCE_OPTION_LABEL_KEYS: Record<
  ComplianceAnswerOption,
  TranslationKey
> = {
  [ComplianceAnswerOption.unset]: InspectionTranslationKeys.unset,
  [ComplianceAnswerOption.passed]: InspectionTranslationKeys.passed,
  [ComplianceAnswerOption.notPassed]: InspectionTranslationKeys.notPassed,
  [ComplianceAnswerOption.notApplicable]: InspectionTranslationKeys.notApplicable,
};

export function complianceOptionLabelKey(
  option: ComplianceAnswerOption
): TranslationKey {
  return COMPLIANCE_OPTION_LABEL_KEYS[option];
}
